import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserRepository } from '../../../domain/repositories/user.repository';
import { UserModel } from '../../../domain/models/user/user.model';
import { UserImplementationRepositoryMapper } from './mappers/user-repository.mapper';
import { UserEntity } from './entities/user.entity';
import { UserRequestModel } from '../../../domain/models/user/user-request.model';
import { UserOtpModel } from '../../../domain/models/user/user-otp.model';
import { UserOtpEntity } from './entities/user-otp.entity';
import { UserOtpImplementationRepositoryMapper } from './mappers/user-otp-repository.mapper';
import { UserValidateOtpImplementationRepositoryMapper } from './mappers/user-validate-otp.repository.mapper';
import { UserChangePasswordImplementationRepositoryMapper } from './mappers/user-change-password-repository.mapper';
import { UserValidateOtpModel } from '../../../domain/models/user/user-validate-otp.model';
import { UserValidateOtpEntity } from './entities/user-validate-otp.entity';
import { UserChangePasswordModel } from '../../../domain/models/user/user-change-password.model';
import { UserChangePasswordEntity } from './entities/user-change-password.entity';
import { UserRecaptchaValidateModel } from '../../../domain/models/user/user-recaptcha-validate.model';
import { UserRecaptchaValidateEntity } from './entities/user-recaptcha-validate.entity';
import { UserValidateRecaptchaImplementationRepositoryMapper } from './mappers/user-validate-recaptcha.repository';
import { UserTourImplementationRepositoryMapper } from './mappers/user-tour-repository.mapper';
import { UserTourModel } from '../../../domain/models/user/user-tour.model';
import { UserTourEntity } from './entities/user-tour.entity';
import { UserProfileEntity } from './entities/user-profile.entity';
import { UserProfileModel } from '../../../domain/models/user/user-profile.model';
import { UserProfileImplementationRepositoryMapper } from './mappers/user-profile-repository.mapper';
import { DataBasicProfileImplementationRepositoryMapper } from './mappers/data-basic-profile-repository.mapper';
import { DataBasicProfileResultImplementationRepositoryMapper } from './mappers/data-basic-profile-result-repository.mapper';
import { ProfilePhotoImplementationRepositoryMapper } from './mappers/profile-photo-repository.mapper';
import { DataBasicProfileModel } from '../../../domain/models/user/data-basic-profile.model';
import { DataBasicProfileEntity } from './entities/data-basic-profile.entity';
import { DataBasicProfileResultModel } from '../../../domain/models/user/data-basic-profile-result.model';
import { DataBasicProfileResultEntity } from './entities/data-basic-profile-result.entity';
import { ProfilePhotoEntity } from './entities/profile-photo.entity';
import { ProfilePhotoModel } from '../../../domain/models/user/profile-photo.model';
import { ProfileResponseImplementationRepositoryMapper } from './mappers/profile-response-repository.mapper';
import { ProfileResponseModel } from '../../../domain/models/user/profile-response.model';
import { ProfileResponseEntity } from './entities/profile-response.entity';


@Injectable({
    providedIn: 'root',
})
export class UserImplementationRepository extends UserRepository {
    userMapper = new UserImplementationRepositoryMapper();
    userOtpMapper = new UserOtpImplementationRepositoryMapper();
    userValidateOtpMapper = new UserValidateOtpImplementationRepositoryMapper();
    userChangePasswordOtpMapper = new UserChangePasswordImplementationRepositoryMapper();
    userValidateRecaptcha = new UserValidateRecaptchaImplementationRepositoryMapper();
    userTour = new UserTourImplementationRepositoryMapper();
    userProfile = new UserProfileImplementationRepositoryMapper();
    dataBasicProfile = new DataBasicProfileImplementationRepositoryMapper();
    dataBasicProfileResult = new DataBasicProfileResultImplementationRepositoryMapper();
    profilePhoto = new ProfilePhotoImplementationRepositoryMapper();
    profileResponse = new ProfileResponseImplementationRepositoryMapper();

    url = environment.baseUrl;
    constructor(private http: HttpClient) {
        super();
    }

    override loginUser(params: UserRequestModel): Observable<UserModel> {
        return this.http.post<UserEntity>(`${this.url}/Usuarios/Authenticate`,params)
        .pipe(map(this.userMapper.mapFrom));
    }

    override sendOtpChangePassword(params: {nombreUsuario:string}): Observable<UserOtpModel> {
        return this.http.post<UserOtpEntity>(`${this.url}/Usuarios/BuildSendOTPChangePassword`,params)
        .pipe(map(this.userOtpMapper.mapFrom));
    }

    override validateOtpChangePassword(params: {usuario:string,OTP:string}): Observable<UserValidateOtpModel> {
        return this.http.post<UserValidateOtpEntity>(`${this.url}/Usuarios/ValidateOTPChangePassword`, params)
        .pipe(map(this.userValidateOtpMapper.mapFrom));
    }

    override changePassword(params:{usuario:string, password:string}): Observable<UserChangePasswordModel> {
        return this.http.post<UserChangePasswordEntity>(`${this.url}/Usuarios/UsuarioChangePassword`, params)
        .pipe(map(this.userChangePasswordOtpMapper.mapFrom));
    }


    override validateRecaptcha(params: {recaptcha:string}): Observable<UserRecaptchaValidateModel> {
        return this.http.post<UserRecaptchaValidateEntity>(`${this.url}/Usuarios/VerifyCaptcha`, params)
        .pipe(map(this.userValidateRecaptcha.mapFrom));
    }

    override getStateTour(): Observable<UserTourModel> {
        return this.http.get<UserTourEntity>(`${this.url}/Usuarios/MostrarTour`)
            .pipe(map(this.userTour.mapFrom));
    }

        override getUserProfile(): Observable<UserProfileModel> {
        return this.http.get<UserProfileEntity>(`${this.url}/MiPerfil/GetProfile`)
            .pipe(map(this.userProfile.mapFrom));
    }

        override updatePersonalInfoProfile(params: DataBasicProfileModel): Observable<DataBasicProfileResultModel> {
        return this.http.post<DataBasicProfileResultEntity>(`${this.url}/MiPerfil/UpdateProfile`,params)
        .pipe(map(this.dataBasicProfileResult.mapFrom));
    }

        override getProfilePhoto(): Observable<ProfilePhotoModel> {
        return this.http.post<ProfilePhotoEntity>(`${this.url}/MiPerfil/GetProfilePhoto`,{})
        .pipe(map(this.profilePhoto.mapFrom));
    }

        override updateProfilePhoto(archivo: File): Observable<ProfileResponseModel> {
          const formData = new FormData();
          formData.append('archivo', archivo);
        return this.http.post<ProfileResponseEntity>(`${this.url}/MiPerfil/UpdateProfilePhoto`,formData)
        .pipe(map(this.profileResponse.mapFrom));
    }

        override deleteProfilePhoto(): Observable<ProfileResponseModel> {
        return this.http.post<ProfileResponseEntity>(`${this.url}/MiPerfil/DeleteProfilePhoto`,{})
        .pipe(map(this.profileResponse.mapFrom));
    }

}
